// Calendar View Type Enum
export const CalendarViewTypeEnum = Object.freeze({
  Week: 0,
  Month: 1,
});
